import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'isScanAnswer', standalone: true })
export class IsScanAnswerPipe implements PipeTransform {
	transform(value: string | null | undefined): boolean {
		return /^scan-\d+$/.test((value ?? '').trim());
	}
}
